import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// Domain
import * as Actions from './bulkload.actions';
import { bulkLoadSalesOrders$, bulkLoadFulfillmentPlans$ } from './bulkload.observables';

export const getFulfillmentPlansBulkloadData = (action$) => {
  return action$.pipe(
    ofType(Actions.BULKLOAD_FULFILLMENT_PLANS_REQUEST),
    mergeMap(({ fulfillmentPlanIds }) => {
      return bulkLoadFulfillmentPlans$(fulfillmentPlanIds);
    }),
  );
};

export const getSalesOrdersBulkloadData = (action$) => {
  return action$.pipe(
    ofType(Actions.BULKLOAD_SALES_ORDERS_REQUEST),
    mergeMap(({ salesOrderIds }) => {
      return bulkLoadSalesOrders$(salesOrderIds);
    }),
  );
};
